module.exports = __webpack_public_path__ + "img/img15.009cb353.png";